<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="800" @click:outside="closeModal">
          <v-card class="custom-card pb-120" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">{{
                $t("Edit User")
              }}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form
              ref="addUser"
              v-model="valid"
              lazy-validation
              autocomplete="off"
            >
              <v-card-text class="black--text">
                <v-row>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="name"
                        >{{ $t("First Name")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.firstName"
                        :placeholder="$t('name')"
                        outlined
                        dense
                        :error-messages="errors.firstName"
                        :rules="rules.firstName"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="name"
                        >{{ $t("Last Name")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.lastName"
                        :placeholder="$t('name')"
                        outlined
                        dense
                        :error-messages="errors.lastName"
                        :rules="rules.lastName"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="email"
                        >{{ $t("Email Id")
                        }}<span style="color: red">*</span></label
                      >
                      <v-text-field
                        v-model="user.email"
                        :placeholder="$t('user.emailAddr')"
                        outlined
                        dense
                        :error-messages="errors.email"
                        :rules="rules.email"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="mobile">{{ $t("Mobile Number") }}</label>
                      <v-text-field
                        v-model="user.mobile"
                        :placeholder="$t('user.enterYourPhoneNumber')"
                        outlined
                        dense
                        v-mask="[
                          '+',
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                        ]"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <!-- <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="password">{{ $t("password") }}</label>
                      <v-text-field
                        :type="passwordType"
                        :append-icon="passwordIcon"
                        @click:append="changePasswordType"
                        v-model="user.password"
                        :placeholder="$t('user.enterPassword')"
                        outlined
                        dense
                        autocomplete="on"
                      ></v-text-field>
                    </div>
                  </v-col> -->
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role">Country</label>
                      <v-select
                        v-model="user.countryId"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        placeholder="Select Country"
                        @change="getStateByCountryId"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role">Province State</label>
                      <v-select
                        v-model="user.stateId"
                        :items="states"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        placeholder="Select State"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role"
                        >{{ $t("role")
                        }}<span style="color: red">*</span></label
                      >
                      <v-select
                        v-model="user.role"
                        :items="rolesList"
                        item-text="name"
                        item-value="roleNumber"
                        outlined
                        dense
                        :loading="roleLoading"
                        :placeholder="$t('farm.selectRole')"
                      ></v-select>
                      <span class="errorf">{{ errors.role }}</span>
                    </div>
                  </v-col>
                  <v-col lg="6" md="6" sm="6" xs="12">
                    <div class="form">
                      <label for="role"
                        >{{ $t("Status")
                        }}<span style="color: red">*</span></label
                      >
                      <v-select
                        v-model="user.active"
                        :items="statusList"
                        outlined
                        dense
                        :error-messages="errors.status"
                        :loading="roleLoading"
                        :rules="rules.role"
                        :placeholder="$t('Select Status')"
                      ></v-select>
                      <span class="errorf">{{ errors.role }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="closeModal"
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    width="116"
                    depressed
                    color="primary"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="updateUser"
                    right
                    height="44"
                    width="116"
                    color="primary"
                  >
                    {{ $t("Submit") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import { updateUser, country, getStateByCountry } from "@/graphql/Users.gql";
export default {
  apollo: {
    countries: {
      query: country,
      update: (data) => console.log(data),
      fetchPolicy: "no-cache",
      variables() {},
      result({ data }) {
        console.log(data);
        this.countries = data.country;
      },
    },
  },
  mixins: [loadingMixin],
  created() {
    console.log("correct one");
  },
  computed: {
    dialog() {
      console.log("works 123413242");
      return this.dialogU;
    },
  },
  watch: {
    dialogU(n, o) {
      console.log("n", n);
      console.log("o", o);
    },
  },
  data() {
    return {
      countries: [],
      states: [],
      statusList: [
        { value: 1, text: "Active" },
        { value: 0, text: "Inactive" },
      ],
      rolesList: [
        { name: "Admin", roleNumber: "admin" },
        { name: "Farmer", roleNumber: "farmer" },
      ],
      valid: true,
      departmentList: [],
      roleLoading: false,
      fieldType: { text: "text" },
      error: false,
      errors: {
        name: "",
        email: "",
        mobile: "",
        password: "",
        department: "",
        role: "",
        countryId: null,
        stateId: null,
      },
      editedUser: { ...this.user },
      password: "",
      rules: {
        name: [
          (v) => !!v || this.$t("nameIsRequired"),
          // (v) => this.onlyAlpha(v) || this.$t("nameCanContainOnlyAlphabets"),
        ],
        email: [
          (v) => !!v || this.$t("emailRequired"),
          // (v) => this.validateEmail(v) || this.$t("invalidEmailFormat"),
        ],
        mobile: [
          (v) => !!v || this.$t("mobNumReq"),
          // (v) => this.validMobileNumber(v) || this.$t("invalidMobFormat"),
        ],
        department: [(v) => !!v || this.$t("departmentReq")],
      },
    };
  },
  methods: {
    getStateByCountryId() {
      this.$apollo
        .query({
          query: getStateByCountry,
          variables: {
            stateListInput: {
              countryId: +this.user.countryId,
            },
          },
        })
        .then((data) => {
          if (data?.data?.getStateByCountry?.length) {
            this.states = data.data.getStateByCountry;
          }
        })
        .catch((e) => Promise.reject(e));
    },
    closeModal() {
      console.log("close edit user modal");
      this.$emit("closeUpdateUser");
    },
    async updateUser() {
      // this.loading = true;
      this.startLoading();
      this.user.id = Number(this.user.id);
      if (this.user.__typename) {
        delete this.user.__typename;
      }
      delete this.user.country;
      delete this.user.state;
      let updateRes = await this.$apollo.mutate({
        mutation: updateUser,
        variables: {
          updateUserInput: this.user,
        },
      });

      console.log(updateRes, "updateRes");
      // this.loading = false;
      this.stopLoading();
      this.closeModal();
    },
    changePasswordType() {},
  },
  props: {
    dialogU: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    console.log(this.user);
    if (this.user?.countryId) {
      this.user.countryId = this.user.countryId.toString();
    }
    if (this.user?.stateId) {
      this.user.stateId = this.user.stateId.toString();
    }
    this.getStateByCountryId();
  },
};
</script>

<style lang="scss">
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
  background: #ffffff !important;
  box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
  border-radius: 23px !important;
}
.custom-card .v-card__text {
  width: 100%;
  padding: 37px 60px !important;
}
.card-heading-1 {
  margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
  font-size: 30px;
  font-weight: 700;
}
// .custom-card .form {
// 	margin-bottom: 22px;
// }
.form label {
  display: inline-block;
  max-width: 100%;
  // margin-bottom: 5px;
  font-size: 15px;
  font-family: Poppins-Medium;
}
.form .form-control {
  display: block;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  /* color: #555; */
  background-color: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
}
.form .form-control::placeholder {
  font-size: 13px;
  font-family: pop_regular;
  color: #97a8b8;
}
.form .form-control:focus-visible {
  outline: none;
}
// .form-control-2 {
// 	display: block;
// 	width: 100%;
// 	height: 36px;
// 	padding: 1px 20px;
// 	line-height: 1.5;
// 	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
// 	background: #fff;
// 	border: 1px solid #C7D5E1;
// 	border-radius: 3px;
// 	background-position: calc(100% - 1.20rem) center !important;
// 	-moz-appearance: none !important;
// 	-webkit-appearance: none !important;
// 	appearance: none !important;
// 	background-image: url(/img/drop2.png);
// 	background-repeat: no-repeat;
// 	font-size: 14px;
// 	/* color:#C7D5E1; */
// 	font-family: pop_regular;
// }
.btn-custom-11 .btn-11 {
  width: 135px;
  background: #fff !important;
  color: $outline-color !important;
  border: 1px solid #97a8b8 !important;
}
.btn-custom-11 .btn-22 {
  width: 135px;
  background: $primary-color !important;
  color: #fff !important;
  margin-left: 10px;
}
.btn-custom-11 {
  margin-top: 38px;
}
</style>
